import { gql, type TypedDocumentNode } from '@apollo/client';

import { COMPETITION_COLORS } from '@sorare/core/src/lib/colors';
import { isType } from '@sorare/core/src/lib/gql';
import type { HexColor } from '@sorare/core/src/style/types';

import type { getTaskCompetitionColor_taskInterface } from './__generated__/index.graphql.ts';

export const getTaskCompetitionColor = (
  task: getTaskCompetitionColor_taskInterface,
  fallbackColor: HexColor
): HexColor => {
  if (
    !isType(task, 'CardsCountTask') &&
    !isType(task, 'CompleteCollectionsCountTask')
  ) {
    return fallbackColor;
  }
  if (!task.competition?.slug) {
    return fallbackColor;
  }
  return COMPETITION_COLORS[task.competition?.slug] ?? fallbackColor;
};

getTaskCompetitionColor.fragments = {
  taskInterface: gql`
    fragment getTaskCompetitionColor_taskInterface on TaskInterface {
      id
      ... on CardsCountTask {
        id
        competition {
          slug
        }
      }
      ... on CompleteCollectionsCountTask {
        id
        competition {
          slug
        }
      }
    }
  ` as TypedDocumentNode<getTaskCompetitionColor_taskInterface>,
};
